/**
 * Affaire Detail Formatters
 */

export const fmtCurrency = (n: number | string | undefined | null): string => {
  if (n == null) return '-';
  return new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR' }).format(Number(n));
};

export const fmtDate = (d: string | undefined | null): string => {
  if (!d) return '-';
  try {
    return new Date(d).toLocaleDateString('fr-BE');
  } catch {
    return d;
  }
};

export const fmtDateTime = (d: string | undefined | null): string => {
  if (!d) return '-';
  try {
    return new Date(d).toLocaleDateString('fr-BE') + ' ' +
      new Date(d).toLocaleTimeString('fr-BE', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return d;
  }
};

export const fmtRelative = (d: string): string => {
  const m = Math.floor((Date.now() - new Date(d).getTime()) / 60000);
  if (m < 1) return "à l'instant";
  if (m < 60) return `il y a ${m}min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `il y a ${h}h`;
  const days = Math.floor(h / 24);
  return `il y a ${days}j`;
};

export const getStageLabel = (status: string): string => {
  // Return a shortened/clean label
  if (status.startsWith('RV en attente')) return 'RV en attente';
  if (status.startsWith('Attente paiement')) return 'Attente paiement';
  if (status.startsWith('Attente confirmation')) return 'Attente confirmation';
  if (status.includes('rappel')) return 'Rappel paiement';
  if (status === 'à transmettre' || status === 'A transmettre') return 'À transmettre';
  return status;
};

export const getDaysSince = (d: string | undefined | null): number | null => {
  if (!d) return null;
  try {
    return Math.floor((Date.now() - new Date(d).getTime()) / 86400000);
  } catch {
    return null;
  }
};
